import type { Prompt } from '@/lib/prompt-lib-utils';
import { cn } from '@/lib/utils';

import { PromptCard } from './prompt-card';

interface PromptSectionProps {
  title: string;
  prompts: Prompt[];
  isMobile?: boolean;
}

export function PromptSection({ title, prompts, isMobile }: PromptSectionProps) {
  if (prompts.length === 0) {
    return null;
  }

  return (
    <section className={cn(isMobile ? "mb-4" : "mb-5")}>
      <div className="rounded-xl bg-white dark:bg-card border border-border/50 p-4 sm:p-5">
        <h2 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3 px-1">{title}</h2>
        <div className={cn(
          "grid gap-3",
          isMobile
            ? "grid-cols-1"
            : "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
        )}>
          {prompts.map((prompt) => (
            <PromptCard
              key={prompt.id}
              id={prompt.id}
              title={prompt.title}
              description={prompt.description}
              stackType={prompt.stackType}
              isMobile={isMobile}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
